import PaymentForm from './PaymentForm';
import { useEffect, useState } from 'react';
import CouponComponent from './Coupon';
import { ShipSlider } from './Sliders';
import { ImageDiv } from '../helper/image';

function Cart({cart, setState, setCart, state, setTransactionId, setTotalPrice, stripePromise, user}) {
  const [discount, setDiscount] = useState({success:false, data: {code:null, applied_cart:null, applied_total: null}});
  const [ship, toggleShip] = useState(false);
  const [message, setMessage] = useState("");
  const shipCost = 11;

  useEffect(() => {
    console.log(discount);
  }, [])

  const decrementItem = (index) => {
    setDiscount({success:false, data: {applied_cart:null, applied_total: null}});
    setMessage();
    setCart(prevCart => {
      const newCart = [...prevCart];
  
      // Decrement the quantity at the given index
      newCart[index].count -= 1;
  
      // Check if count has reached 0 after decrementing, then remove the item
      if (newCart[index].count <= 0) {
        newCart.splice(index, 1);
      }
  
      return newCart;
    });
  };
  

  // Calculate the total price for all items in the cart
  const calculateTotalPrice = (ship) => {
    let applied_total = getCartPrice();
    if (discount.success) {
      applied_total = Number(discount.data.applied_total);
    }
    setTotalPrice((applied_total + (ship? shipCost : 0)).toFixed(2));
    return (applied_total + (ship? shipCost : 0)).toFixed(2);
  };

  function getCartPrice() {
    return Number((cart.reduce((total, item) => total + (item.price * item.count), 0)));
  }

  function getAmountSaved() {
    return (getCartPrice() - calculateTotalPrice()).toFixed(2);
  }

  return (
    <div>
      {cart.length > 0 && (
        <div id="cart">
          <div>
            {cart.map((item, index) => (
              <div className="cart-item" key={index}>
                  <ImageDiv itemName={item.name} type={item.type} imageUrl={item.imageUrl}/>
                  <div>
                    <h2>{item.name}</h2>
                    <h3>${item.price} x {item.count}</h3>
                  </div>
                  <button className='remove-button' onClick={() => decrementItem(index)}>Remove</button>
              </div>
            ))}
          </div>
          <ShipSlider toggleShip={toggleShip} shipCost={shipCost}/>
          <div className='row'>
            <h1>Total: ${calculateTotalPrice(ship)}</h1>
            {/* <div>(incl. GST ${Number(calculateTotalPrice(ship) * 0.1).toFixed(2)})</div> */}
            <h6>(incl. GST)</h6>
          </div>

          {discount.success ? <>Saved ${getAmountSaved()}!</> : null}
          <CouponComponent setDiscount={setDiscount} cart={cart} message={message} setMessage={setMessage}/>
          <PaymentForm user={user} setTransactionId={setTransactionId} totalPrice={calculateTotalPrice(ship)} cart={cart} setState={setState} shippingPaid={ship} couponCode={discount.data.coupon} stripePromise={stripePromise}/>
        </div>
      )}
    </div>)
}

export default Cart